import React from 'react';
// import { FaUser } from "react-icons/fa";
import UserCard from '../../UserCard/UserCard';

export default ({
  eventData = {},
  useSectionStyle
}) => {
  const {
    primaryContactName = '',
    primaryContactEmail = '',
    primaryContactPhone = ''
  } = eventData;

  const headerStyle = useSectionStyle ?
    {
      color: '#565656',
      fontSize: '24px',
      fontWeight: 'bold',
      marginTop: '20px',
      marginLeft: '20px'
    } :
    {
      color: '#565656',
      fontSize: '17px',
      fontWeight: 'bold',
      padding: '20px',
      borderBottom: '1px solid #C2C9D1'
    }

  return (
    <div 
      style={{ 
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={headerStyle} >
        {'Primary Contact'}
      </div>
      <UserCard name={primaryContactName} email={primaryContactEmail} phone={primaryContactPhone} hideBorder={true} />
      {/* <div style={{
        display: 'flex',
        padding: '20px',
        alignItems: 'flex-start'
      }}>
        <div style={{
          height: '50px',
          width: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '22px',
          background: '#C2C9D1',
          color: '#ffffff',
          borderRadius: '50%',
        }}>
          <FaUser />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '0px 10px 10px 20px',
          overflow: 'hidden',
          wordWrap: 'break-word'
        }}>
          <div style={{
            marginBottom: '10px',
            fontWeight: 'bold'
          }}>
            {primaryContactName}
          </div>
          <div style={{
            marginBottom: '5px',
            color: '#565656',
          }}>
            {primaryContactPhone}
          </div>
          <div style={{ color: '#0280c6', textDecoration: 'underline' }}>
            {primaryContactEmail}
          </div>
        </div>
      </div> */}
    </div>
  )
}